<!-- 期货日内交易账号申请的条款内容 -->
<template>
  <div class="article-content">
    <!-- TODO checkbox样式丢失 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
      <el-row class="mt-10">
        <el-form-item prop="checked1">
          <el-checkbox v-model="ruleForm.checked1" :disabled="!isFinishRead" test_id= "checkbox1">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.fdtmAgreeText.text1')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>
      <el-row class="mt-10">
        <el-form-item prop="checked2">
          <el-checkbox v-model="ruleForm.checked2" :disabled="!isFinishRead" test_id= "checkbox2">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.fdtmAgreeText.text2')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>

      <el-row class="mt-10">
        <el-form-item prop="checked3">
          <el-checkbox v-model="ruleForm.checked3" :disabled="!isFinishRead" test_id= "checkbox3">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.fdtmAgreeText.text3')}}
            </span>
          </el-checkbox>
        </el-form-item>
      </el-row>
      <e-row class="mt-10">
        <el-form-item prop="checked4">
          <el-checkbox v-model="ruleForm.checked4" test_id= "checkbox4" :disabled="!isFinishRead">
            <span class="font-s-pf">
              {{$t('applyTradeAccount.infomationTips.textOne')}}
            </span>
          </el-checkbox>
          <a :href="$t('applyTradeAccount.infomationTips.linkOne')" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkOneText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.textTwo')}}</span>
          <a :href="standingLink" target="_blank">
            <span class="statement">{{$t('applyTradeAccount.infomationTips.linkTwoText')}}</span>
          </a>
          <span class="font-s-pf">{{$t('applyTradeAccount.infomationTips.lastText')}}</span>
        </el-form-item>
      </e-row >

      <el-form-item>
        <div class="apply-btn" v-show="isShowButton">
          <el-button @click="submitForm('ruleForm')" test_id= "createAccount">
            {{status==='reject'?$t('applyTradeAccount.reSubmit'):$t('applyTradeAccount.confirm')}}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getAgreementContent } from '@/api/v2/deposit.js'
export default {
  props: {
    isFinishRead: {
      type: Boolean,
      default: false
    },
    isShowButton: {
      type: Boolean,
      default: true
    },
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    let checkedVal = (rule, value, callback) => {
      let f = rule.field
      if (!this['ruleForm'][f]) {
        return callback(new Error(this.$t('applyTradeAccount.checked')))
      }
      callback()
    }
    return {
      ruleForm: {
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false
      },
      rules: {
        checked1: [{
          validator: checkedVal
        }],
        checked2: [{
          validator: checkedVal
        }],
        checked3: [{
          validator: checkedVal
        }],
        checked4: [{
          validator: checkedVal
        }]
      },
      standingLink: ''
    }
  },
  created() {
    this.getAgreementContentFun()
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit('submitForm', { agree: true })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取常设授权链接
    async getAgreementContentFun() {
      let params = {
        platform: 'H5',
        type: 'Standing_Authority'
      }
      let res = await getAgreementContent(params)
      if (res.code === 200) {
        this.standingLink = res.data && res.data.path
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.article-content{
  a {
    text-decoration: none;
  }
  .el-checkbox__inner::after {
    height: 12px;
    left: 8px;
    top: 3px;
    width: 3px;
  }
  .el-checkbox__inner {
    width: 22px;
    height: 22px;
  }
  .apply-btn {
    margin-top: 20px;
    .el-button {
      width: 250px;
      height: 56px;
      border-radius: 5px;
      background-color: #fec000;
      color: #182a54;
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      font-family: PingFangSC-Semibold;
    }
  }
  .statement{
    font-size: 16px;
  }
}
</style>
